import React, { useState } from 'react';
import { toast } from 'sonner';

interface RankBadgeProps {
  rank?: 'watcher' | 'legion' | 'verified' | 'union' | string | null;
  size?: number;
  className?: string;
}

const RankBadge: React.FC<RankBadgeProps> = ({ rank, size = 18, className }) => {
  const [error, setError] = useState(false);

  if (!rank || rank.toLowerCase() === 'none' || error) return null;

  // Assuming rank names match your filenames exactly (e.g., watcher.png)
  // Note: Since this is an absolute path, ensure your images are placed in: public/assets/rankbadges/
  const badgePath = `/assets/rankbadges/${rank.toLowerCase()}.png`;

  const handleBadgeClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    const capitalizedRank = rank.charAt(0).toUpperCase() + rank.slice(1).toLowerCase();
    toast(`This user is a ${capitalizedRank} member.`, {
      icon: <img src={badgePath} style={{ width: '20px', height: '20px', objectFit: 'contain' }} />,
      duration: 3000,
    });
  };

  return (
    <img
      src={badgePath}
      alt={`${rank} badge`}
      onClick={handleBadgeClick}
      onError={() => setError(true)}
      className={`cursor-pointer hover:scale-110 transition-transform active:scale-95 ${className || ''}`}
      style={{
        width: `${size}px`,
        height: `${size}px`,
        display: 'inline-block',
        verticalAlign: 'middle',
        objectFit: 'contain'
      }}
    />
  );
};

export default RankBadge;
